module.exports = __webpack_public_path__ + "img/sld.b3eea593.jpg";